import styled from 'styled-components';
import { Box, Absolute, Button, Text } from '@rsos/components/capstone/base';

export const Container = styled(Box)`
  position: relative;
`;
export const MapControlsWrapper = styled(Absolute).attrs({
  top: 7,
  left: 7,
})`
  background: ${({ theme }) => theme.colors.background};
  width: 210px;
  z-index: 1;
  padding: 14px;
  border-radius: 5px;
`;

export const ReviewModalButton = styled(Button).attrs({
  noMargin: true,
})`
  width: 170px;
`;

export const TextArea = styled.textarea`
  border: 1px solid ${({ theme }) => theme.colors.lightLineDivider};
  padding: 10px;
  color: ${p => p.theme.colors.primaryText};
  background: ${p => p.theme.colors.background};
`;

export const StyledCheckbox = styled.input.attrs({
  type: 'checkbox',
})`
  width: 13px;
  height: 13px;
`;
export const MapControlsRow = styled(Box).attrs({
  horizontal: true,
  flow: 5,
  align: 'center',
})``;

export const MapControlsText = styled(Text).attrs({
  size: 'small',
  color: 'secondaryText',
})``;
